// extracted by mini-css-extract-plugin
module.exports = {"Container":"Pagination_Container__3cZsU","PageNumber":"Pagination_PageNumber__nfiz4","Active":"Pagination_Active__3eZjO"};